import { useParams } from 'react-router-dom'
import DepartmentForm from './DepartmentForm'

const View = () => {
    const params = useParams()

    return (
        <DepartmentForm
            id={parseInt(params.departmentId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Department updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update department',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating department...',
                },
            }}
        />
    )
}

export default View
